<div class="modal-container">
  <div class="modal-content">
    <h1 class="modal-title">Move Group to Another Customer</h1>
    <div class="modal-description">
      <p class="warning-text">
        Changing the customer for
        <strong class="group-name-highlight">'{{ data.groupName }}'</strong>
        will also move
        <strong>{{ data.deviceCount }}</strong>
        associated device{{ data.deviceCount === 1 ? '' : 's' }} to the new customer.
        Group and device customer assignments will stay in sync.
      </p>
      <div class="group-detail">
        <ul>
          <li>
            <span class="detail-label">Group:</span>
            <span class="detail-value">{{ data.groupName || 'N/A' }}</span>
          </li>
          <li>
            <span class="detail-label">Devices:</span>
            <span class="detail-value">{{ data.deviceCount }}</span>
          </li>
          <li>
            <span class="detail-label">From:</span>
            <span class="detail-value">{{ data.currentCustomerName || 'N/A' }}</span>
          </li>
          <li>
            <span class="detail-label">To:</span>
            <span class="detail-value">{{ data.newCustomerName || 'N/A' }}</span>
          </li>
        </ul>
      </div>
      <p class="warning-text secondary">
        If any device cannot be updated (for example, an asset name conflict), the entire
        change will be cancelled and nothing will be saved.
      </p>
    </div>
    <div class="button-container">
      <button type="button" class="btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn-confirm" (click)="onConfirm()">
        Yes, Move Group &amp; Devices
      </button>
    </div>
  </div>
</div>
